<template>
    <PlantConfigurationAlerts :plantID="plantID"></PlantConfigurationAlerts>
</template>

<script>
import PlantConfigurationAlerts from '@/components/plants/configuration/PlantConfigurationAlerts.vue';

export default {
    components: {
        PlantConfigurationAlerts
    },
    data() {
        return {
            
        };
    },
    computed: {
        plantID() {
            return parseInt(this.$route.params.plantID);
        }
    },
    methods: {

    },
    created() {
        
    }
}
</script>

<style>

</style>
